import { FC } from 'react';
import { GridLegacy as Grid } from '@mui/material';
import { MovieCardSkeleton } from './movie-card-skeleton';

export const MovieListLoader: FC<{
  count?: number;
}> = ({ count = 4 }) => {
  return (
    <Grid
      container
      columnSpacing={{
        mobile: 2,
        extraLargeDesktop: 7.16,
      }}
      rowSpacing={{
        mobile: 2.98,
        extraLargeDesktop: 9.75,
      }}
      sx={{
        width: '100%',
      }}
    >
      {Array(count)
        .fill(0)
        .map((_, index) => (
          <Grid key={index} item mobile={6} tablet={4} desktop={3}>
            <MovieCardSkeleton />
          </Grid>
        ))}
    </Grid>
  );
};
